import { useSelector } from "react-redux";

import Mini from "/components/common/product/mini";
import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "addQuestion";

export default function AddQuestion() {
  const { data } = useSelector((state) => state.popup);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      goalOpen={GOALS.productQuestionOpen}
      goalSent={GOALS.productQuestionSent}
      filterField={({ CODE }) => CODE !== "form_text_109"}
      extraData={() => ({
        form_text_109: data?.id,
      })}
      successText={(r) =>
        `Вопрос отправлен. Номер вашего вопроса #${r.success}`
      }
    >
      <Mini productId={data?.id} />
      <p>
        Вы также можете задать вопрос в{" "}
        <a href="https://t.me/farkop_rubot" target="_blank" rel="noreferrer">
          Telegram
        </a>{" "}
        или{" "}
        <a href="https://wa.me/+79811779326" target="_blank" rel="noreferrer">
          Whatsapp
        </a>
      </p>
    </PopupFormWrapper>
  );
}
